import * as Sentry from '@sentry/react'

// see https://docs.sentry.io/platforms/javascript/
const blacklistUrls = [
  /\.wistia\.com/i,
  /cnd\.pendo\.io/i,
  /js\.stripe\.com/i,
  /widget\.trustpilot\.com/i
]

const ignoreErrors = [
  /window\.optimizely is undefined/i,
  /ResizeObserver loop limit exceeded/i,
  /ResizeObserver loop completed/i,
  /fbq is not defined/i
]

export function initSentry() {
  if (window.Sentry) {
    // already initialized
    return
  }

  if (!process.env.REACT_APP_SENTRY_DSN) {
    return
  }

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.SENTRY_RELEASE_ID || '1.0.0',
    tags: {
      git_commit: 'gitCommit',
      userLevel: 'editor'
    },
    environment: process.env.REACT_APP_JUNGLE_ENV,
    blacklistUrls,
    ignoreErrors
  })
  window.Sentry = Sentry
}

/**
 * Logs a Sentry exception
 * @param {Error} ex - Exception Error
 * @param {{tags: Object, extra: Object, contexts: Object, user: Object, level: 'info'|'debug'|'warning'|'error'}} context
 */
export function logExceptionNoConsole(ex, context) {
  window.Sentry?.captureException(ex, context)
}

/**
 * Logs a Sentry exception and also logs as an error on the console
 * @param {Error} ex - Exception Error
 * @param {{tags: Object, extra: Object, contexts: Object, user: Object, level: 'info'|'debug'|'warning'|'error'}} context
 */
export function logException(ex, context) {
  logExceptionNoConsole(ex, context)
  /* eslint no-console:0 */
  console.error(`sentry.logException => ${ex}`)
}

export function setSentryUserData(user) {
  if (!user || !window.Sentry) {
    return
  }

  window.Sentry.setUser({
    id: user.id
  })

  window.Sentry.setTag('page_locale', user.selected_language)
}

export function setSentryMWSData({ amazon_seller_account_id, marketplace_id }) {
  if (!window.Sentry) {
    return
  }

  if (amazon_seller_account_id) {
    window.Sentry.setTag('amazon_seller_account_id', amazon_seller_account_id)
  }

  if (marketplace_id) {
    window.Sentry.setTag('marketplace_id', marketplace_id)
  }
}
